"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeUriPath = void 0;
var tslib_1 = require("tslib");
var escape_uri_1 = require("./escape-uri");
function escapeUriPath(uri) {
    var e_1, _a;
    var parts = [];
    try {
        for (var _b = tslib_1.__values(uri.split("/")), _c = _b.next(); !_c.done; _c = _b.next()) {
            var sub = _c.value;
            parts.push(escape_uri_1.escapeUri(sub));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return parts.join("/");
}
exports.escapeUriPath = escapeUriPath;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXNjYXBlLXVyaS1wYXRoLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2VzY2FwZS11cmktcGF0aC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O0FBQUEsMkNBQXlDO0FBQ3pDLFNBQWdCLGFBQWEsQ0FBQyxHQUFXOztJQUN2QyxJQUFNLEtBQUssR0FBYSxFQUFFLENBQUM7O1FBQzNCLEtBQWtCLElBQUEsS0FBQSxpQkFBQSxHQUFHLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFBLGdCQUFBLDRCQUFFO1lBQTdCLElBQU0sR0FBRyxXQUFBO1lBQ1osS0FBSyxDQUFDLElBQUksQ0FBQyxzQkFBUyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUM7U0FDNUI7Ozs7Ozs7OztJQUNELE9BQU8sS0FBSyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQztBQUN6QixDQUFDO0FBTkQsc0NBTUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBlc2NhcGVVcmkgfSBmcm9tIFwiLi9lc2NhcGUtdXJpXCI7XG5leHBvcnQgZnVuY3Rpb24gZXNjYXBlVXJpUGF0aCh1cmk6IHN0cmluZyk6IHN0cmluZyB7XG4gIGNvbnN0IHBhcnRzOiBzdHJpbmdbXSA9IFtdO1xuICBmb3IgKGNvbnN0IHN1YiBvZiB1cmkuc3BsaXQoXCIvXCIpKSB7XG4gICAgcGFydHMucHVzaChlc2NhcGVVcmkoc3ViKSk7XG4gIH1cbiAgcmV0dXJuIHBhcnRzLmpvaW4oXCIvXCIpO1xufVxuIl19